import type { LeadStartEvent } from './LeadStartEvent';
import { leadStartSchema } from './LeadStartSchema';

type Props = {
  leadType: string;
  listingId: string | null;
  ctaLocation: string;
  financeQuoteChecked?: boolean;
};

export const leadStartToEvent = ({
  leadType,
  listingId,
  ctaLocation,
  financeQuoteChecked,
}: Props): LeadStartEvent => {
  const event: LeadStartEvent = {
    schema: leadStartSchema.ref,
    data: {
      lead_type: leadType,
      listing_id: listingId,
      cta_location: ctaLocation,
      finance_quote_checked: financeQuoteChecked,
    },
  };

  return event;
};
